<template>
  <form :action="action_url" method="POST" accept-charset="UTF-8">
    <input type="hidden" name="_token" :value="csrf_token">
    <section class="section--sidebar-user">
      <section class="section--title-sidebar">
        <h3>Assegnazione massiva permessi</h3>      
      </section>
      <section class="section--content-sidebar section--content-sidebar-full-height">      
          <h4>
              Seleziona le persone che riceveranno la visibilità dei documenti di questa cartella.<br>
              I permessi delle sottocartelle non saranno alterati da questa operazioni.
          </h4>
          <br>
          <div class="row">
              <div class="col-6 form-group">
              <label>Tipologia utente</label>
              <select
                  v-model="typology_id"
                  name="typology"
                  @change="selectTypology($event)"
                  class="form-control"
              >
                  <option value="null">---</option>
                  <option v-for="row in people_typology" :value="row.id">
                  {{ row.name }}
                  </option>
              </select>
              </div>
              <div class="col-6 form-group">
              <label>Persona</label>
              <select
                  v-model="person_id"
                  name="person"
                  @change="insertPerson($event)"
                  class="form-control"
              >
                  <option value="null">---</option>
                  <option v-for="row in people_select" :value="row.id">
                  {{ row.name }}
                  </option>
              </select>
              </div>
              <div class="col-3">
                  <a href="#" class="btn btn-small" @click="addAllTypology()">
                      Aggiungi tutti
                  </a>
              </div>
              <div class="col-3">
                  <a href="#" class="btn btn-small" @click="destroyAllPeople()">
                      Elimina tutti
                  </a>
              </div>
              <div class="col-3">
                  <a href="#" class="btn btn-small" @click="setCheckAllPeople(1)">
                      Seleziona tutti
                  </a>
              </div>
              <div class="col-3">
                  <a href="#" class="btn btn-small" @click="setCheckAllPeople(0)">
                      Deseleziona tutti
                  </a>
              </div>
              <div class="col-12 mt-2">
                <div>Persone totali: {{ people_reader.length }}</div>
                <div>Persone selezionate: {{ people_added.length }}</div>
              </div>
          </div>
        <hr />
        <div class="people-reader">
          <table class="table table-condensed">
            <thead>
              <tr>
                <th></th>              
                <th>Nome</th>
                <th>Rapporto</th>
                <th>Lettura</th>
                <th>Feedback (email)</th>              
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in people_added">                
                <td>
                  <a href="#" @click="deleteRow(row.id)"
                    ><i class="fa fa-trash"></i>
                  </a>
                  <input
                    type="hidden"
                    :value="row.id"
                    :name="'person[' + row.id + ']'"
                  />
                </td>              
                <td>{{ row.name }}</td>
                <td>{{ row.typology }}</td>
                <td>                
                  <input
                    type="checkbox"
                    value="1"
                    :name="'person[' + row.id + '][can_see]'"                  
                    v-model="row.can_see"
                  />
                </td>
                <td>                
                  <input
                    type="checkbox"
                    value="1"
                    :name="'person[' + row.id + '][flag_email_feedback]'"                  
                    v-model="row.flag_email_feedback"
                  />
                </td>              
              </tr>
            </tbody>
          </table>
        </div>
        <div class="form-buttons clear mb-4">
           <button type="submit" class="btn btn--primary">
              <i class="fa fa-save"></i>
              Salva
          </button>
        </div>
      </section>      
    </section>
  </form>
</template>
<script>
export default {
  mounted() {
    for (let i = 0; i < this.people_reader.length; i++){      
      this.people_reader[i].can_see = false;
      this.people_reader[i].flag_email_feedback = false;
    }
    this.action_url = "people-media/action/store-file-from-folder/" + this.folder_id;
  },
  data() {
    return {
      action_url: "",
      typology_id: null,
      person_id: null,
      people_select: [],
      people_added: [],
    };
  },
  props: {
    people_reader:{
      type: Array,
      required: true,
    },
    people_typology: {
      type: Array,
      required: true,
    },
    folder_id: {
      type: Number,
      required: true,
    },
    csrf_token:{
      type: String,
      required: true,
    }
  },
  methods: {
    destroyAllPeople() {

      if (this.typology_id == null || this.typology_id == "null"){
        this.people_added = [];
        return;
      }

      if (this.people_select && this.people_select.length > 0){        
          let result = this.people_added;
          for(let a = 0; a < this.people_select.length; a++){            
            for(let i = 0; i < this.people_added.length; i++){
              if(this.people_select[a].id == this.people_added[i].id){
                result.splice(i, 1);
              }
            }            
          }

          this.people_added = result;
      }
    },
    addAllTypology() {

      if (this.typology_id == null || this.typology_id == "null"){
        this.people_added = this.people_reader;
        return;
      }

      if (this.people_select && this.people_select.length > 0){        
          let result = this.people_added;
          for(let a = 0; a < this.people_select.length; a++){
            let exists = false;
            for(let i = 0; i < this.people_added.length; i++){
              if(this.people_select[a].id == this.people_added[i].id){
                exists = true;
              }
            }
            if (!exists){
              result.push(this.people_select[a]);
            }
          }

          this.people_added = result;
      }      
    },
    getPeople(event) {
      if (event.target.value == "null"){
        this.people_select = [];
        return;
      }
      this.typology_id = event.target.value;      
    },
    deleteRow(row_id) {
      for(let r = 0; r < this.people_added.length; r++){
        if (this.people_added[r].id == row_id){
          this.people_added.splice(r, 1);
        }
      }
    },
    selectTypology(event) {
        var typology = event.target.value;
        this.people_select = this.people_reader.filter(obj => {
          return obj.typology_id === parseInt(typology);
        });                
    },
    insertPerson(event) {

      let person_id = event.target.value;      
      let person = null;

      for(let r = 0; r < this.people_reader.length; r++){
        if (this.people_reader[r].id == person_id){
          person = this.people_reader[r];
        }
      }

      if (person == null){
        return;
      }
              
      let result = this.people_added;          
      let exists = false;
      for(let i = 0; i < this.people_added.length; i++){
        if(person_id == this.people_added[i].id){
          exists = true;
        }
      }
      if (!exists){
        result.push(person);
      }
    },    
    setCheckAllPeople(set) {
      for(let r = 0; r < this.people_added.length; r++){          
        this.people_added[r].can_see = set;
        this.people_added[r].flag_email_feedback = set;
      }
    },
  },
};
</script>
<style>
.custom-actions button.ui.button {
  padding: 8px 8px;
}
.custom-actions button.ui.button > i.icon {
  margin: auto !important;
}
</style>